__turbopack_context__.v({
  "className": "ohgtbG_className",
});
